
import { GamePlayScreen } from "../screens/GamePlayScreen";
import type { DailyPuzzle } from "@/lib/types/game";
import type { Word, LogicRule } from "@/lib/game-utils";

interface GamePlayContainerProps {
  puzzle: DailyPuzzle;
  onComplete: (
    result: "perfect" | "almost" | "wrong", 
    solveTime: number, 
    selectedWords: Array<{ word: Word; order: number }>,
    selectedRule: LogicRule,
    rules: LogicRule[]
  ) => void;
}

export function GamePlayContainer({ puzzle, onComplete }: GamePlayContainerProps) {
  return (
    <GamePlayScreen
      puzzle={puzzle}
      onComplete={onComplete}
    />
  );
}
